// @ts-nocheck
import React, { FC } from 'react';

import unescapeChars from 'Shared/StringParser/unescapeChars';

type ItemProps = {
  item: {
    id: number;
    question: string;
    answer: string;
  };
};

const Item: FC<ItemProps> = ({ item }) => {
  return (
    <li className="mb-40">
      <p className="font-subtitle1 text-left text-white mb-16">
        {item.question}
      </p>
      <p
        className="font-body3 text-gray-main"
        dangerouslySetInnerHTML={{ __html: unescapeChars(item.answer) }}
      />
    </li>
  );
};

export default Item;
